/**
 * Curated set of Lucide icons available for navigation items.
 * Stored in Firestore as the icon name string (e.g. "Home", "Phone").
 */

import {
  Home,
  Phone,
  Mail,
  Users,
  User,
  FileText,
  Settings,
  Shield,
  Star,
  Search,
  Globe,
  Calendar,
  Briefcase,
  BookOpen,
  MessageSquare,
  Heart,
  DollarSign,
  CheckCircle,
  Zap,
  Info,
  ArrowRight,
  Award,
  Building2,
  Lock,
  TrendingUp,
  LayoutGrid,
  ClipboardList,
  HelpCircle,
  type LucideIcon,
} from 'lucide-react';

export const NAV_ICON_MAP: Record<string, LucideIcon> = {
  Home,
  Phone,
  Mail,
  Users,
  User,
  FileText,
  Settings,
  Shield,
  Star,
  Search,
  Globe,
  Calendar,
  Briefcase,
  BookOpen,
  MessageSquare,
  Heart,
  DollarSign,
  CheckCircle,
  Zap,
  Info,
  ArrowRight,
  Award,
  Building2,
  Lock,
  TrendingUp,
  LayoutGrid,
  ClipboardList,
  HelpCircle,
};

export type NavIconName = keyof typeof NAV_ICON_MAP;

/** Render a nav icon by name. Returns null if name is not found. */
export function NavIconRenderer({
  name,
  size = 16,
  className,
}: {
  name: string | null | undefined;
  size?: number;
  className?: string;
}): React.ReactElement | null {
  if (!name) return null;
  const Icon = NAV_ICON_MAP[name];
  if (!Icon) return null;
  return <Icon size={size} className={className} />;
}
